<template>
  <b-form id="campaign-winner-info" @submit.prevent="onSubmitForm">
    <b-row>
      <b-col cols="12">
        <b-card no-body class="mb-1 pb-4 container-card">
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <div
                    class="row pl-1 mt-3 justify-content-between align-item-center"
                  >
                    <div class="font-medium-5 font-weight-bolder text-black">
                      {{ isEdit ? "Edit Campaign" : "Create Campaign" }}
                    </div>

                    <div>
                      <save-button type="submit" class="ml-1" />
                    </div>
                  </div>
                  <div
                    class="row pl-1 mt-1 font-medium-5 font-weight-bolder text-black"
                  >
                    Campaign Information
                  </div>
                  <div class="row">
                    <div class="col-md-9 mt-2">
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <div class="d-flex">
                            <span class="status-toggle font-medium-5"
                              >{{ "Status" }}
                            </span>
                            <b-form-checkbox
                              fieldValue="true"
                              class="custom-control-success ml-4"
                              name="check-button"
                              switch
                              v-model="formData.status"
                            >
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <b-form-group
                            :label="'Campaign Name (Thai)'"
                            label-for="campagin-name"
                            label-class="font-medium-5 required"
                          >
                            <b-form-input
                              id="campaign-name"
                              v-model="formData.campaignNameTh"
                              placeholder="ระบุ"
                              required
                            />
                          </b-form-group>
                        </div>
                        <div class="col-12 col-md-6">
                          <b-form-group
                            :label="'Campaign Name (English)'"
                            label-for="campagin-name"
                            label-class="font-medium-5"
                          >
                            <b-form-input
                              id="campaign-name"
                              v-model="formData.campaignNameEn"
                              placeholder="ระบุ"
                            />
                          </b-form-group>
                        </div>
                      </div>
                      <b-row id="Valid-date">
                        <b-col cols="6">
                          <div class="d-flex">
                            <div class="p-0 p-relative mr-2">
                              <b-form-group
                                :label="'Valid From'"
                                label-for="campagin-name"
                                label-class="title-name font-medium-4 mt-2 required"
                              >
                                <flat-pickr
                                  :id="'valid-from-date'"
                                  v-model="formData.validFrom.date"
                                  class="form-control bg-date"
                                  :class="
                                    formData.validFrom.date
                                      ? 'date-selected'
                                      : null
                                  "
                                  :config="flatpickrDateConfig"
                                  placeholder="Select Date"
                                  autocomplete="off"
                                  required
                                  @on-open="
                                    flatpickrDateConfig.maxDate =
                                      formData.validThrough.date
                                  "
                                />
                                <calendar-picker-icon
                                  class="icon-calendar bypass"
                                  :class="
                                    formData.validFrom.date
                                      ? 'date-selected-icon'
                                      : null
                                  "
                                />
                              </b-form-group>
                            </div>
                            <div class="p-0 p-relative">
                              <b-form-group
                                :label="'Time'"
                                label-for="campagin-name"
                                label-class="title-name font-medium-4 mt-2 required"
                              >
                                <flat-pickr
                                  id="valid-from-time"
                                  v-model="formData.validFrom.time"
                                  class="form-control bg-date"
                                  :class="
                                    formData.validFrom.time
                                      ? 'date-selected'
                                      : null
                                  "
                                  :config="flatpickrTimeConfig"
                                  :placeholder="'Select Time'"
                                  autocomplete="off"
                                  required
                                  @on-change="
                                    () => {
                                      if (
                                        formData.validFrom.date ==
                                          formData.validThrough.date &&
                                        formData.validFrom.time >
                                          formData.validThrough.time
                                      ) {
                                        formData.validThrough.time = null;
                                      }
                                    }
                                  "
                                />
                                <clock-picker-icon
                                  class="icon-calendar date-picker-icon bypass"
                                  :class="
                                    formData.validFrom.time
                                      ? 'date-selected-icon'
                                      : null
                                  "
                                />
                              </b-form-group>
                            </div>
                          </div>
                        </b-col>
                        <b-col cols="6">
                          <div class="d-flex">
                            <div class="p-0 p-relative mr-2">
                              <b-form-group
                                :label="'Valid Through'"
                                label-for="campagin-name"
                                label-class="title-name font-medium-4 mt-2 required"
                              >
                                <flat-pickr
                                  :id="'valid-through-date'"
                                  v-model="formData.validThrough.date"
                                  class="form-control bg-date"
                                  :class="
                                    formData.validThrough.date
                                      ? 'date-selected'
                                      : null
                                  "
                                  :config="flatpickrDateConfig"
                                  placeholder="Select Date"
                                  autocomplete="off"
                                  required
                                  @on-open="
                                    flatpickrDateConfig.minDate =
                                      formData.validFrom.date
                                  "
                                />
                                <calendar-picker-icon
                                  class="icon-calendar bypass"
                                  :class="
                                    formData.validThrough.date
                                      ? 'date-selected-icon'
                                      : null
                                  "
                                />
                              </b-form-group>
                            </div>
                            <div class="p-0 p-relative">
                              <b-form-group
                                :label="'Time'"
                                label-for="campagin-name"
                                label-class="title-name font-medium-4 mt-2 required"
                              >
                                <flat-pickr
                                  id="valid-from-time"
                                  v-model="formData.validThrough.time"
                                  class="form-control bg-date"
                                  :class="
                                    formData.validThrough.time
                                      ? 'date-selected'
                                      : null
                                  "
                                  :config="flatpickrTimeConfig"
                                  :placeholder="'Select Time'"
                                  autocomplete="off"
                                  required
                                  @on-open="
                                    () => {
                                      if (
                                        formData.validFrom.date ==
                                        formData.validThrough.date
                                      ) {
                                        flatpickrTimeConfig.minTime =
                                          formData.validFrom.time;
                                      }
                                    }
                                  "
                                />
                                <clock-picker-icon
                                  class="icon-calendar date-picker-icon bypass"
                                  :class="
                                    formData.validThrough.time
                                      ? 'date-selected-icon'
                                      : null
                                  "
                                />
                              </b-form-group>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 border-b" v-if="isEdit">
                  <div
                    class="row pl-1 mt-1 mb-1 font-medium-5 font-weight-bolder text-black justify-content-end align-item-center"
                  >
                    <lucky-draw-button
                      class="ml-1 mr-1"
                      v-if="roundListTable.payload.length > 0"
                      @click.native="openRoundAndRewardModal"
                      :btn-label="'Round and Reward List'"
                      :isShowIconAdd="true"
                    />
                  </div>

                  <div class="row">
                    <b-col cols="12" class="mb-1">
                      <overlay-loading :loading="loading.tableData">
                        <template #content>
                          <b-table
                            :fields="fields"
                            :items="roundListTable.payload"
                            responsive
                            bordered
                            borderless
                            sticky-header
                            show-empty
                            class="default-static-table"
                          >
                            <template #head(seq)="data">
                              <div class="text-center">
                                {{ data.label }}
                              </div>
                            </template>

                            <template #cell(round_id)="data">
                              {{ data.item.round.round_id }}
                            </template>

                            <template #cell(round_name_th)="data">
                              {{ data.item.round.round_name_th }}
                            </template>
                            <template #cell(status)="data">
                              <b-form-checkbox
                                field-value="true"
                                class="custom-control-success"
                                name="check-button"
                                switch
                                :checked="
                                  data.item.round.status == 1 ? true : false
                                "
                                @change="
                                  onToggleStatus($event, data.item.round)
                                "
                              >
                              </b-form-checkbox>
                            </template>

                            <template #cell(valid_form)="data">
                              <span>{{
                                `${
                                  data.item.round.valid_form
                                    ? resolveDate(data.item.round.valid_form)
                                    : formData.validFrom.date
                                } ${
                                  data.item.round.valid_form
                                    ? resolveTime(data.item.round.valid_form)
                                    : formData.validFrom.time
                                }`
                              }}</span>
                            </template>
                            <template #cell(valid_through)="data">
                              <span>
                                {{
                                  `${
                                    data.item.round.valid_through
                                      ? resolveDate(
                                          data.item.round.valid_through
                                        )
                                      : formData.validThrough.date
                                  }
                                ${
                                  data.item.round.valid_through
                                    ? resolveTime(data.item.round.valid_through)
                                    : formData.validThrough.time
                                }`
                                }}</span
                              >
                            </template>

                            <template #cell(actions)="data">
                              <action-group
                                :resolve-action="resolveMappingTableAction"
                                :set-action-list="LuckyDrawActionList"
                                :item-data="data"
                              />
                            </template>
                            <template #empty>
                              <content-no-item
                                :textNoImg="'Round and Reward'"
                                :actionFunc="openRoundAndRewardModal"
                                :isShowIconAdd="true"
                              />
                            </template>
                          </b-table>
                        </template>
                      </overlay-loading>
                    </b-col>
                    <b-col cols="12">
                      <pagination-with-reorder
                        entity-editable
                        :pagination="pagination"
                        @entityChange="onFilterEntity"
                        @pageChange="onPageChange"
                      />
                    </b-col>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <round-and-reward-modal
      v-if="modalType.roundReward"
      :is-edit="isEditRound"
      :formDataObj="formRoundItem"
      @onSubmitRoundReward="onSubmitRoundReward"
      @onCloseModal="onCloseModalRound"
    />
  </b-form>
</template>

<script>
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker2.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import flatPickr from "vue-flatpickr-component";
import useCampaignWinnerInfo from "./hooks/useCampaignWinnerInfo";
import ImageUpload from "@/views/components/image-upload/ImageUpload.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import ContentNoItem from "@/@core/components/card-no-item/ContentNoItemLuckyDraw.vue";
import RoundAndRewardModal from "./RoundAndRewardModal.vue";
import LuckyDrawButton from "@/views/components/button/LuckyDrawButton.vue";

export default {
  components: {
    CalendarPickerIcon,
    ClockPickerIcon,
    flatPickr,
    ImageUpload,
    ActionGroup,
    PaginationWithReorder,
    ContentNoItem,
    RoundAndRewardModal,
    LuckyDrawButton,
  },

  setup() {
    const {
      formData,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onSubmitForm,
      onUploadMainImg,
      onUploadSubImg,
      onNumberInput,
      loading,
      fields,
      roundListTable,
      LuckyDrawActionList,
      resolveMappingTableAction,
      pagination,
      onPageChange,
      onFilterEntity,
      openRoundAndRewardModal,
      modalType,
      onCloseModalRound,
      isEdit,
      formRoundItem,
      isEditRound,
      onSubmitRoundReward,
      formRoundReward,

      onToggleStatus,
      resolveDateWithSeperator,
      resolveDate,
      resolveTime,
      // customQuillOption,
    } = useCampaignWinnerInfo();

    return {
      formData,
      CalendarPickerIcon,
      ClockPickerIcon,
      flatPickr,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onSubmitForm,
      onUploadMainImg,
      onUploadSubImg,
      onNumberInput,
      loading,
      fields,
      roundListTable,
      LuckyDrawActionList,
      resolveMappingTableAction,
      pagination,
      onPageChange,
      onFilterEntity,
      openRoundAndRewardModal,
      modalType,
      onCloseModalRound,
      isEdit,
      formRoundItem,
      isEditRound,
      onSubmitRoundReward,
      formRoundReward,

      onToggleStatus,
      resolveDateWithSeperator,
      resolveDate,
      resolveTime,
      // customQuillOption,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.ql-snow {
  .ql-picker {
    &.ql-size {
      .ql-picker-label,
      .ql-picker-item {
        &::before {
          content: attr(data-value) !important;
        }
      }
    }
  }
}
</style>

<style>
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px";
  font-size: 14px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px";
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
  font-size: 18px !important;
}

#campaign-winner-info .editor-wrp {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
}

#campaign-winner-info .custom-tab .tab-content {
  height: 100%;
}

#campaign-winner-info .nav-tabs {
  margin-bottom: -0.7rem !important;
}
</style>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/pages/default-static-table.css";
.border-b {
  padding-bottom: 30px;
  border-top: 1px solid #ececec;
}

#Valid-date .icon-calendar {
  left: 11px;
  top: calc(68% - 10px);
  fill: #6c8baf !important;
}

#Valid-date .form-control {
  padding: 0.438rem 1rem 0.438rem 3rem;
}

#Valid-date .date-picker-icon {
  top: 68% !important;
}

#campaign-winner-info.input-group-text {
  color: #a2a2a2;
}

#campaign-winner-info .desc-title {
  color: #cecece;
}

#campaign-winner-info .bg-date {
  border: 1px solid #6c8baf !important;
  color: #728aac !important;
}

#campaign-winner-info .bg-date::placeholder {
  color: #728aac !important;
}

#campaign-winner-info .hover-day {
  position: absolute;
  top: 57px;
  left: 40px;
  font-size: 1.5rem;
  color: #728aac;
}

#campaign-winner-info .bg-date:hover {
  background-color: #6c8baf !important;
  color: #eee !important;
}

#campaign-winner-info .bg-date:hover ~ .hover-day {
  background-color: #6c8baf !important;
  color: #eee !important;
}

#campaign-winner-info .bg-date:hover ~ .icon-calendar {
  fill: #eee !important;
}

#campaign-winner-info .bg-date:hover::placeholder {
  color: #eee !important;
}

#campaign-winner-info .bg-date:hover ~ .date-picker-icon {
  fill: #eee !important;
}
</style>
